import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, CardContent, Chip, Typography } from '@mui/material';

import styles from './DoctorCard.module.css';
import { RootState } from '../../../../store';
import { useAppointmentService } from '../../../../hooks';
import { Doctor } from '../../../../../domain/entities';
import { formatTime } from '../../../../../utils/dates';

interface Props {
  doctor: Doctor;
  medicalCenter: string;
  schedules: Date[];
  onScheduleClicked: (doctor: Doctor, schedule: Date) => void;
}

const DoctorCard = ({ doctor, medicalCenter, schedules, onScheduleClicked }: Props) => {
  const AppointmentService = useAppointmentService();

  const [availableSchedules, setAvailableSchedules] = useState<Date[]>([]);

  useEffect(() => {
    AppointmentService.listByDoctor(doctor.id)
      .then((data) => {
        const unavailableDateStrings = data.map((appointment) => appointment.startDate.toString());
        const filteredSchedules = schedules.filter(
          (schedule) => !unavailableDateStrings.includes(schedule.toString())
        );
        setAvailableSchedules(filteredSchedules);
      })
      .catch((err) => console.log(err));
  }, []);

  const appointment = useSelector((state: RootState) => state.appointment);
  return (
    <Card sx={{ boxShadow: 3, borderRadius: 3, p: 1 }}>
      <CardContent>
        <Typography className={styles.name} color='primary' variant='body1'>
          {doctor.name}
        </Typography>
        <Typography className={styles.specialty} color={doctor.specialty.color} variant='caption'>
          {doctor.specialty.name}
        </Typography>
        <Typography className={styles.medicalCenter} color='text.secondary' variant='caption'>
          {medicalCenter}
        </Typography>
        <Box pt={1}>
          {availableSchedules.map((date) => (
            <Chip
              key={date.getTime().toString()}
              sx={{ m: 1, minWidth: '85px' }}
              color='primary'
              variant={
                appointment.schedule.datetimeInMilliseconds === date.getTime() &&
                appointment.doctor.id === doctor.id
                  ? 'filled'
                  : 'outlined'
              }
              label={formatTime(date)}
              onClick={() => onScheduleClicked(doctor, date)}
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default DoctorCard;
